import {
  Input,
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { BasicSelectModalComponent } from '../../framework/modals/components/basic-select-modal/basic-select-modal.component';

@Directive({
  selector: '[appBasicSelect]',
})
export class BasicSelectDirective {
  @Input() centered?: boolean = true;
  @Input() scrollParentToTop = false;
  @Input() allItems: any[];

  private _modalTitle: string;
  @Input() set modalTitle(value: string) {
    this._modalTitle = value || '';
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.modalTitle = value;
    }
  }

  private _idProperty: string;
  @Input() set idProperty(value: string) {
    this._idProperty = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.idProperty = value;
    }
  }

  private _extraEndpointData: {};
  @Input() set extraEndpointData(value: {}) {
    this._extraEndpointData = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.extraEndpointData = value;
    }
  }


  private _displayProperties: {
    property: string;
    display: string;
    classes?: string[];
    sortable?: boolean;
    filterable?: boolean;
    status?: boolean;
    visible?: boolean;
  }[];
  @Input() set displayProperties(
    value: { property: string; display: string; classes?: string[]; sortable?: boolean; filterable?: boolean; status?: boolean; visible?: boolean }[]
  ) {
    this._displayProperties = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.displayProperties = value;
    }
  }

  private _multiSelect = true;
  @Input() set multiSelect(value: boolean) {
    this._multiSelect = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.multiSelect = value;
    }
  }

  // private _itemList: any[];
  // @Input() set itemList(value: any[]) {
  //   this._itemList = value;
  //   if (this._modalRef) {
  //     this.getComponentInstance().itemList = value;
  //   }
  // }
  private _endPointId: number;
  @Input() set endPointId(value: number) {
    this._endPointId = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.endPointId = value;
    }
  }

  private _itemEndPoint: string;
  @Input() set itemEndPoint(value: string) {
    this._itemEndPoint = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.itemEndPoint = value;
    }
  }

  private _countEndPoint: string;
  @Input() set countEndPoint(value: string) {
    this._countEndPoint = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.countEndPoint = value;
    }
  }

  private _selectedItems: any[];
  @Input() set selectedItems(value: any[]) {
    this._selectedItems = value;
    let instance = this.getComponentInstance();
    if (this._modalRef && instance) {
      instance.selectedList = value;
    }
  }

  @Output() confirmed: EventEmitter<any[]> = new EventEmitter<any[]>();

  private _modalRef: NgbModalRef;
  private modalOptions: NgbModalOptions = {
    size: 'lg',
    centered: true,
    windowClass: 'selectModal',
    backdrop: 'static',
  };

  public constructor(
    private _element: ElementRef,
    private _modalService: NgbModal
  ) { }

  @HostListener('click')
  public onClick(): void {
    this.openModal();
  }

  public openModal(): void {
    if (this.scrollParentToTop) {
      this.scrollEmbeddedParentsToTop();
    }
    this.modalOptions = { ...this.modalOptions, centered: this.centered };
    this._modalRef = this._modalService.open(
      BasicSelectModalComponent,
      this.modalOptions
    );

    const component: BasicSelectModalComponent = this._modalRef
      .componentInstance as BasicSelectModalComponent;
    component.modalTitle = this._modalTitle;
    component.idProperty = this._idProperty;
    component.extraEndpointData = this._extraEndpointData;
    component.displayProperties = this._displayProperties;
    component.centered = this.centered;
    component.multiSelect = this._multiSelect;
    component.endPointId = this._endPointId;
    component.itemEndPoint = this._itemEndPoint;
    component.countEndPoint = this._countEndPoint;
    component.selectedList = this._selectedItems;
    component.allItems = this.allItems;
    component.confirm.subscribe((items: any[]) => {
      this.confirmSelection(items);
    });
    this._modalRef.result
      .then(
        () => { },
        () => { }
      )
      .catch(() => {
        this._modalRef = null;
      });
  }

  public confirmSelection(items: any[]) {
    this.confirmed.emit(items);
    this._modalRef.dismiss();
    this._modalRef = null;
  }

  public getComponentInstance(): BasicSelectModalComponent {
    if (this._modalRef && this._modalRef.componentInstance) {
      return this._modalRef.componentInstance as BasicSelectModalComponent;
    }
    return null;
  }

  private scrollEmbeddedParentsToTop(): void {
    let parentWindow = window.parent;
    while (parentWindow && parentWindow !== parentWindow.parent) {
      parentWindow.scrollTo(0, 0);
      parentWindow = parentWindow.parent;
    }
  }
}
